import React from "react";

const IconHome: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <g clipPath="url(#clip0_19_452)">
        <path
          d="M7.6628 3.46379C7.61918 3.42167 7.56115 3.39816 7.50079 3.39816C7.44042 3.39816 7.38239 3.42167 7.33877 3.46379L1.94522 8.66517C1.92232 8.68729 1.90409 8.71387 1.89165 8.7433C1.87922 8.77274 1.87282 8.80441 1.87286 8.83641L1.87198 13.7181C1.87198 13.9691 1.97075 14.2098 2.14657 14.3873C2.32238 14.5648 2.56084 14.6645 2.80948 14.6645H5.62491C5.74923 14.6645 5.86846 14.6146 5.95636 14.5259C6.04427 14.4371 6.09366 14.3168 6.09366 14.1913V10.1691C6.09366 10.1063 6.11835 10.0461 6.1623 10.0018C6.20626 9.95739 6.26587 9.93246 6.32803 9.93246H8.67178C8.73394 9.93246 8.79356 9.95739 8.83751 10.0018C8.88146 10.0461 8.90616 10.1063 8.90616 10.1691V14.1913C8.90616 14.3168 8.95554 14.4371 9.04345 14.5259C9.13136 14.6146 9.25059 14.6645 9.37491 14.6645H12.1892C12.4378 14.6645 12.6763 14.5648 12.8521 14.3873C13.0279 14.2098 13.1267 13.9691 13.1267 13.7181V8.83641C13.1267 8.80441 13.1203 8.77274 13.1079 8.7433C13.0954 8.71387 13.0772 8.68729 13.0543 8.66517L7.6628 3.46379Z"
          fill="white"
        />
        <path
          d="M14.3824 7.68975L12.191 5.57336V2.36179C12.191 2.23629 12.1416 2.11593 12.0537 2.02719C11.9658 1.93845 11.8465 1.88859 11.7222 1.88859H10.316C10.1917 1.88859 10.0724 1.93845 9.98452 2.02719C9.89661 2.11593 9.84723 2.23629 9.84723 2.36179V3.3082L8.15035 1.67033C7.99156 1.50826 7.75543 1.41539 7.50026 1.41539C7.24596 1.41539 7.01041 1.50826 6.85162 1.67062L0.620181 7.68916C0.437954 7.86661 0.415103 8.15852 0.580923 8.35076C0.622563 8.39928 0.673548 8.43874 0.730776 8.46674C0.788004 8.49474 0.850277 8.5107 0.913806 8.51363C0.977335 8.51656 1.04079 8.50641 1.10031 8.4838C1.15983 8.46119 1.21417 8.42659 1.26002 8.38211L7.33912 2.51795C7.38274 2.47583 7.44077 2.45232 7.50114 2.45232C7.5615 2.45232 7.61953 2.47583 7.66315 2.51795L13.7428 8.38211C13.8324 8.46881 13.9523 8.51612 14.0764 8.51368C14.2005 8.51124 14.3185 8.45925 14.4046 8.36909C14.5845 8.181 14.5696 7.87046 14.3824 7.68975Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_452">
          <rect
            width="15"
            height="15.1425"
            fill="white"
            transform="translate(-9.91821e-05 0.468109)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconHome;
